import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import RemoveRedEye from '@material-ui/icons/RemoveRedEye';
import { Api } from '../../utils/api';


class EntitiesListTable extends React.Component {

  constructor() {
    super();
    this.goTo = this.goTo.bind(this);
    this.api = new Api();
  }

  goTo(location,params) {
    this.props.history.push(location,params);
  }

  
  render() {

    const { entities } = this.props;
    const { classes } = this.props;

    return (
      <div className="main-reqlist-container">
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Nome</TableCell>
                <TableCell align="left">NIF</TableCell>
                <TableCell align="left">Ver detalhe</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {entities && entities.map(entity => (
                <TableRow key={entity.id}>
                  <TableCell align="left">{entity.name}</TableCell>
                  <TableCell align="left">{entity.nif}</TableCell>
                  <TableCell align="left">
                    <Button color="primary" className={classes.button} onClick={() => this.goTo(`/entities/${entity.id}`)}>
                      <RemoveRedEye className={classes.leftIcon} />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
});

EntitiesListTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(EntitiesListTable));